import { Delete } from "lucide-react";

export default function NumpadTactile({ value, onChange }) {
  const press = (key) => {
    if (key === "C") {
      onChange("");
      return;
    }
    if (key === ",") {
      if (value.includes(",")) return;
      onChange((value || "0") + ",");
      return;
    }
    if (key === "back") {
      onChange(value.slice(0, -1));
      return;
    }
    // digit
    let next = value === "0" ? key : value + key;
    onChange(next);
  };

  const keys = ["7", "8", "9", "4", "5", "6", "1", "2", "3", "C", "0", ","];

  return (
    <div className="grid grid-cols-3 gap-2 sm:gap-3">
      {keys.map((k) => (
        <button
          key={k}
          type="button"
          data-testid={k === "C" ? "numpad-key-clear" : `numpad-key-${k === "," ? "comma" : k}`}
          onClick={() => press(k)}
          className={`min-h-[64px] rounded-xl border-2 font-mono text-2xl sm:text-3xl font-extrabold active:scale-95 transition-transform ${
            k === "C"
              ? "bg-amber-400 border-amber-500 text-slate-900 hover:bg-amber-300"
              : "bg-slate-100 border-slate-300 text-slate-800 hover:bg-slate-200"
          }`}
        >
          {k}
        </button>
      ))}
      <button
        type="button"
        data-testid="numpad-key-back"
        onClick={() => press("back")}
        className="col-span-3 min-h-[56px] rounded-xl border-2 bg-slate-800 border-slate-900 text-white font-bold flex items-center justify-center gap-2 active:scale-95 transition-transform hover:bg-slate-700"
      >
        <Delete className="w-6 h-6" /> Effacer un chiffre
      </button>
    </div>
  );
}
